import React from 'react';
import styled from 'styled-components';
import useAxios from 'axios-hooks';
import { Button } from 'components/shared';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: flex-start;
`;

// Admin-configured links (Orbital-admin's "Webpages" resource, see
// windTurbineWebpages route) - opens a real popup window (not just a new
// tab - specifying width/height/etc. in the features string is what makes
// browsers render it as its own window).
//
// webpage.url is deliberately NOT what gets opened directly - it's the
// bridge's own LAN target (e.g. "http://192.168.1.20/"), which the
// FIRMWARE fetches on the server's behalf (see Orbital-server's
// routes/webpageTunnel.js and Vestas-RCS-PIO's italscada_mqtt.cpp). The
// browser instead opens the tunnel's own public address, one dedicated
// subdomain per webpage (<id>.webpages.italscada.com - see the Caddyfile
// and turbineSchemas/PF2-Vestas-PLAN.md), which reverse-proxies to
// Orbital-server, which relays the fetch over MQTT to the actual device.
// Pointing this at webpage.url directly - tried once, wrongly - made the
// board try to fetch its own *public* tunnel URL as if it were the LAN
// target, i.e. tunneling to itself through the internet, which obviously
// doesn't work (and errors distinctly: a plaintext HTTP request landing on
// Caddy's HTTPS-only port for that domain).
const POPUP_FEATURES = 'width=1200,height=800,noopener,noreferrer';

const tunnelUrl = (webpage) => `https://${webpage.id}.webpages.italscada.com/`;

const Webpages = ({ windTurbine }) => {
  const [{ data, loading }] = useAxios({
    url: '/windTurbineWebpages',
    params: {
      filter: JSON.stringify({ windTurbineId: windTurbine.id }),
    },
  });

  if (loading) {
    return <span>Loading...</span>;
  }

  if (!data || data.length === 0) {
    return <span>No webpages configured for this turbine.</span>;
  }

  const openPopup = (webpage) => {
    window.open(tunnelUrl(webpage), `webpage-${webpage.id}`, POPUP_FEATURES);
  };

  return (
    <Wrapper>
      {data.map((webpage) => (
        <Button key={webpage.id} onClick={() => openPopup(webpage)}>
          {webpage.label}
        </Button>
      ))}
    </Wrapper>
  );
};

Webpages.propTypes = {};

Webpages.defaultProps = {};

export default Webpages;
